import {
  DOCUMENT_UPLOAD_ACCEPT,
  DOCUMENT_UPLOAD_ALLOWED_MIME_TYPES,
  DOCUMENT_UPLOAD_MAX_SIZE_BYTES,
  EVIDENCE_UPLOAD_ACCEPT,
  IMAGE_UPLOAD_ACCEPT,
  IMAGE_UPLOAD_ALLOWED_MIME_TYPES,
  IMAGE_UPLOAD_MAX_SIZE_BYTES,
  isAllowedDocumentMimeType,
  isAllowedImageMimeType,
  isDocumentWithinSizeLimit,
  isImageWithinSizeLimit,
  isValidEvidenceFile,
} from "@vardic/shared/utils/document-upload";
import i18n from "@/locales";

export {
  DOCUMENT_UPLOAD_ACCEPT,
  DOCUMENT_UPLOAD_ALLOWED_MIME_TYPES,
  DOCUMENT_UPLOAD_MAX_SIZE_BYTES,
  EVIDENCE_UPLOAD_ACCEPT,
  IMAGE_UPLOAD_ACCEPT,
  IMAGE_UPLOAD_ALLOWED_MIME_TYPES,
  IMAGE_UPLOAD_MAX_SIZE_BYTES,
  isAllowedDocumentMimeType,
  isAllowedImageMimeType,
  isDocumentWithinSizeLimit,
  isImageWithinSizeLimit,
};

const DOCUMENT_MAX_SIZE_MB = Math.floor(
  DOCUMENT_UPLOAD_MAX_SIZE_BYTES / 1024 / 1024,
);
const IMAGE_MAX_SIZE_MB = Math.floor(
  IMAGE_UPLOAD_MAX_SIZE_BYTES / 1024 / 1024,
);

/**
 * Validates a single evidence file (document OR image) for the
 * upload-and-analyze flow. Returns a localized error string or `null`.
 */
export function validateEvidenceUpload(file: File): string | null {
  const result = isValidEvidenceFile({
    name: file.name,
    type: file.type,
    size: file.size,
  });
  if (result.ok) {
    return null;
  }
  if (result.reason === "too_large") {
    const isImage = file.type.startsWith("image/");
    return isImage
      ? i18n.t("upload:errors.imageTooLarge", { maxSize: IMAGE_MAX_SIZE_MB })
      : i18n.t("upload:errors.fileTooLarge", {
        maxSize: DOCUMENT_MAX_SIZE_MB,
      });
  }
  return i18n.t("upload:errors.invalidFileType");
}
